export default "__VITE_ASSET__c8e9432e__"